import type { Copy } from './types'

export const es: Copy = {
  nativeName: 'Español',
  a11y: {
    mainNav: 'Navegación principal',
    logo: 'La Reina Beauty Salon',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    instagram: 'Instagram de La Reina Beauty Salon',
    tiktok: 'TikTok de La Reina Beauty Salon',
    loading: 'Cargando La Reina Beauty Salon',
    fiveStars: '5 de 5 estrellas',
    serviceTabs: 'Categorías de servicios',
    languageSwitcher: 'Idioma del sitio',
    switchTo: 'Ver el sitio en español',
    whatsappCta: 'Reservar por WhatsApp al',
  },
  whatsappMessage: 'Hola La Reina Beauty Salon, quiero reservar una cita',
  walkIns: 'Walk-ins Welcome · Sin Cita Necesaria',
  ctaShort: 'Walk-ins Welcome · Sin Cita Necesaria',
  nav: {
    links: [
      { id: 'experiencia', label: 'Experiencia' },
      { id: 'servicios', label: 'Servicios' },
      { id: 'resenas', label: 'Reseñas' },
      { id: 'nosotras', label: 'Nosotras' },
      { id: 'horario', label: 'Horario' },
      { id: 'contacto', label: 'Contacto' },
    ],
  },
  hero: {
    location: 'Staten Island, New York',
    title: 'Tu cabello. Tu corona. Tu momento.',
    subtitle: 'Arte, precisión y pasión — en cada servicio.',
    secondaryCta: 'Ver servicios',
    ratingNote: 'cientos de reseñas reales',
  },
  highlights: {
    eyebrow: 'El Arte de La Reina',
    title: '¿Qué pasaría si en un solo lugar encontraras todo lo que tu cabello necesita?',
    intro:
      'Un equipo que sabe lo que hace y resultados que hablan solos — sin ir de salón en salón.',
    items: [
      {
        title: 'Un corte que realmente te favorece',
        lead: 'No el corte que el estilista quería hacerte.',
        body: 'El corte que tú pediste. El que lleva semanas en tu mente. En La Reina te escuchamos antes de tomar las tijeras, porque un buen corte no empieza con las manos — empieza con los oídos.',
      },
      {
        title: 'El blowout dominicano que todas buscan',
        lead: 'Hay blow drys. Y luego está el blowout dominicano de La Reina.',
        body: 'Suave. Brillante. Con movimiento. Con vida. El tipo de resultado que hace que la gente te pregunte qué te hiciste — y tú solo sonríes.',
      },
      {
        title: 'Color que transforma sin destruir',
        lead: 'Muchas han tenido miedo al color después de una mala experiencia.',
        body: 'Aquí el color es ciencia y arte a la vez. Elegimos la técnica según tu tipo de cabello, tu historial y tu objetivo — para darte el resultado que quieres sin comprometer su salud.',
      },
      {
        title: 'Tratamientos premium que sí restauran',
        lead: '¿Reseco? ¿Sin brillo? ¿Quebradizo? ¿Dañado por años de químicos o calor?',
        body: 'No necesitas resignarte, necesitas el tratamiento correcto. Ofrecemos los protocolos más avanzados del mercado: los que nutren y devuelven la vida desde adentro hacia afuera.',
      },
      {
        title: 'Extensiones de cabello 100% humano',
        lead: '¿Más largo? ¿Más volumen? ¿Una transformación completa?',
        body: 'No solo aplicamos extensiones — vendemos cabello 100% humano directamente en el salón. No tienes que buscar el cabello en otro lugar y luego volver. Aquí encuentras todo.',
      },
      {
        title: 'Tu evento especial merece un look especial',
        lead: 'Graduación. Boda. Quinceañera. Aniversario. Cena especial.',
        body: 'Ese momento importa, y tu cabello también. En La Reina te preparamos para los momentos que no se olvidan.',
      },
    ],
    eventTestimonial: {
      quote:
        'Nelly hizo un trabajo increíble en mi cabello para la graduación de mi hija. Wash, corte y blowout. Tan feliz con mi corte. Carmen también estuvo increíble con el cabello de mi hija para su graduación.',
      author: 'Carmen C.',
    },
  },
  services: {
    eyebrow: 'Todos nuestros servicios',
    title: 'Todo en un solo lugar',
    intro: 'Elige una categoría para ver el detalle completo de cada servicio.',
    countLabel: 'servicios',
    categories: [
      {
        label: 'Cortes y Estilismo',
        title: 'Cortes y estilismo general',
        columnLabel: 'Descripción',
        imageAlt: 'Corte en capas con blow dry dominicano y acabado brillante',
        rows: [
          {
            name: 'Hair Cut',
            description: 'Corte personalizado según tu tipo de rostro, textura y objetivo de estilo',
          },
          {
            name: 'Trimming / Puntas',
            description: 'Eliminación de puntas dañadas para estimular el crecimiento sano',
          },
          {
            name: 'Blow Dry',
            description: 'Secado profesional con técnica dominicana para máximo brillo y suavidad',
          },
          {
            name: 'Wrap',
            description: 'Técnica de envoltura para un acabado liso, suave y con movimiento natural',
          },
          {
            name: 'Rollers',
            description: 'Peinado con rolos para definición de rizos y ondas duraderas',
          },
          {
            name: 'Rollers + Blow Dry',
            description: 'Combinación de rolos y blow dry para mayor volumen y durabilidad',
          },
          {
            name: 'Wash + Set',
            description: 'Lavado completo más peinado final listo para cualquier ocasión',
          },
          {
            name: 'Up Styles',
            description: 'Peinados recogidos elegantes para eventos, bodas y ocasiones especiales',
          },
          {
            name: 'Curls',
            description: 'Rizos definidos y duraderos con técnica profesional',
          },
          {
            name: 'Pony Tail',
            description: 'Cola de caballo estilizada, desde la más natural hasta la más glamorosa',
          },
        ],
      },
      {
        label: 'Servicios de Color',
        title: 'Servicios de color',
        columnLabel: 'Descripción',
        imageAlt: 'Color vino intenso con ondas definidas realizado en el salón',
        rows: [
          {
            name: 'Permanent Color',
            description:
              'Color permanente de alta cobertura con fórmulas profesionales para resultados intensos y duraderos',
          },
          {
            name: 'Highlights',
            description:
              'Mechas estratégicamente colocadas para dar dimensión, luz y movimiento a tu cabello',
          },
          {
            name: 'Balayage',
            description:
              'Técnica de degradado artístico a mano para un efecto natural y sofisticado',
          },
          {
            name: 'Color Rinse',
            description:
              'Baño de color temporal que aporta brillo y tonalidad sin comprometer la estructura del cabello',
          },
          {
            name: 'Semi-Permanent',
            description: 'Color semi-permanente que enriquece el tono sin daño químico agresivo',
          },
          {
            name: 'Color Reverse',
            description:
              'Proceso especializado para revertir o corregir colores anteriores con seguridad',
          },
          {
            name: 'Low Lights',
            description:
              'Mechas oscuras estratégicas que dan profundidad y dimensión al color base',
          },
        ],
      },
      {
        label: 'Tratamientos Premium',
        title: 'Tratamientos premium de restauración',
        columnLabel: '¿Para qué es?',
        imageAlt: 'Cabello negro tratado con brillo espejo y ondas voluminosas',
        rows: [
          {
            name: 'Bio Plastia',
            description:
              'Sella la fibra capilar, elimina el frizz, aporta brillo intenso y suavidad extrema desde la primera sesión',
          },
          {
            name: 'Botanical Smoothing',
            description:
              'Alisado progresivo con ingredientes 100% botánicos — sin químicos agresivos, sin dañar la estructura natural del cabello',
          },
          {
            name: 'Restructuring',
            description:
              'Reconstrucción profunda fibra por fibra para cabellos severamente dañados por calor, químicos o decoloración',
          },
          {
            name: 'Intensive Nutrition',
            description:
              'Nutrición activa de alta concentración que devuelve fuerza, elasticidad y vitalidad al cabello debilitado',
          },
          {
            name: 'Intensive Hydration',
            description:
              'Hidratación profunda y prolongada para cabellos secos, opacos y sin vida — resultados visibles desde el primer uso',
          },
          {
            name: 'Deep Conditioning',
            description:
              'Acondicionamiento intensivo que restaura la suavidad, el brillo y la manejabilidad del cabello en una sola sesión',
          },
          {
            name: 'Relaxer',
            description:
              'Alisado químico profesional aplicado con precisión y cuidado para respetar la integridad del cabello',
          },
          {
            name: 'Texture',
            description:
              'Proceso de texturizado para definir, suavizar o transformar la textura natural del cabello con control total',
          },
        ],
      },
      {
        label: 'Extensiones y Trenzas',
        title: 'Extensiones y trenzas',
        columnLabel: 'Descripción',
        imageAlt: 'Trenzas con twists y accesorios dorados en cabello infantil',
        rows: [
          {
            name: 'Hair Extensions',
            description:
              'Extensiones profesionales con cabello 100% humano para mayor largo, volumen y transformación completa',
          },
          {
            name: 'Clips On',
            description:
              'Extensiones removibles de fácil colocación — ideales para cambios temporales sin compromiso',
          },
          {
            name: 'Glued',
            description:
              'Extensiones pegadas con adhesivo profesional para un resultado natural y duradero',
          },
          {
            name: 'Sewed In',
            description:
              'Extensiones cosidas sobre trenzas — la técnica más segura y duradera para proteger tu cabello natural',
          },
          {
            name: 'Braids / Trenzas',
            description:
              'Trenzas artísticas desde estilos simples hasta los más elaborados y creativos',
          },
          {
            name: 'Pony Tail con Extensión',
            description:
              'Cola de caballo realzada con cabello adicional para mayor largo y volumen instantáneo',
          },
        ],
      },
    ],
    callout: {
      accent: 'Vendemos cabello 100% humano',
      lead: '',
      rest:
        ' directamente en el salón. No necesitas ir a ningún otro lugar — aquí encuentras el cabello y la aplicación en un solo lugar.',
    },
  },
  testimonials: {
    eyebrow: 'Reseñas verificadas',
    title: 'Clientas reales. Palabras reales. Resultados reales.',
    featured: {
      quote:
        'Absolutamente encantada con el servicio. No hay nada como un blowout dominicano aquí. Se preocupan de verdad por tu cabello y se aseguran de que estés feliz. ¡Este es mi lugar favorito!',
      author: 'Yudelki V.',
    },
    items: [
      {
        quote:
          '¡Experiencia increíble para una chica con cabello natural 4C! Me colorearon, acondicionaron y alisaron el cabello. La dueña fue tan amable en educarme sobre cómo mantener mi color. ¡El personal es increíblemente dulce! Recomiendo 10/10.',
        author: 'CCMedia Mogul',
        meta: 'Local Guide',
      },
      {
        quote:
          'Primera vez en los Estados Unidos y necesitaba un turno antes de una cena. ¡Fueron increíbles! Nunca vi mi cabello tan sano y lacio. Sin duda volvería y lo recomendaría.',
        author: 'Aaliyah L.',
        meta: 'Local Guide',
      },
      {
        quote:
          'Quedé encantada con el servicio que recibí en esta peluquería. El profesionalismo, la experiencia y el trabajo son más que excelentes. ¡Definitivamente soy clienta de por vida!',
        author: 'Melissa B.',
      },
      {
        quote:
          'Me hicieron un wash and set y también me pusieron extensiones. Me encantó. Gente muy amable. Definitivamente volvería.',
        author: 'Alexis C.',
        meta: 'Local Guide',
      },
    ],
  },
  transition: {
    words: [
      'La Reina',
      'Beauty Salon',
      'Entra como clienta. Sale como Reina.',
      'Estilismo Dominicano',
    ],
    stats: {
      precision: { value: 'Precisión', label: 'En cada servicio' },
      services: { value: '', label: 'Servicios' },
      humanHair: { value: '100%', label: 'Cabello humano' },
      hairTypes: { value: 'Todo', label: 'Tipo de cabello' },
    },
  },
  founders: {
    eyebrow: 'Nuestra historia',
    title: 'Conoce a las reinas detrás de La Reina',
    intro:
      'Nelly Vargas y Mervil Granja no abrieron La Reina para ser solo otro salón en la cuadra. Lo abrieron con una misión.',
    quote:
      'La Reina in English meaning Queen — is how we would like for our customers to feel when they leave this salon.',
    body: 'Lo que comenzó como una tradición de estilismo dominicano creció hasta convertirse en una experiencia de belleza universal y completa — atendiendo todo tipo de cabello, toda textura, toda historia capilar. Lo han visto todo. Lo han transformado todo.',
    hairTypes: ['Rizos tipo 3', 'Natural 4C', 'Dañado por químicos', 'Virgen', 'Extensiones'],
    tagline: 'Entra como clienta. Sale como Reina.',
  },
  whyWeWin: {
    eyebrow: 'La diferencia',
    title: 'Por qué La Reina gana — siempre',
    othersHeader: 'Otros salones',
    reinaHeader: 'La Reina Beauty Salon',
    rows: [
      { others: 'Te apuran sin escucharte', reina: 'Se toman el tiempo de escucharte' },
      { others: 'Un servicio igual para todas', reina: 'Personalizado para TU tipo de cabello' },
      { others: 'Dañan y luego reparan', reina: 'Protegen mientras transforman' },
      { others: 'Productos genéricos', reina: 'Tratamientos profesionales premium' },
      { others: 'Fríos y transaccionales', reina: 'Cálidos, acogedores, como familia' },
      { others: 'Solo cortes y color', reina: 'Todo en un solo lugar' },
      {
        others: 'Resultados que duran días',
        reina: 'Resultados que te hacen voltear cabezas toda la semana',
      },
    ],
  },
  brandPromise: {
    quote:
      'No solo hacemos cabello. Restauramos confianza, reconstruimos coronas y te recordamos quién eres.',
    body: 'No tienes que ir a un salón para el color, a otro para las extensiones, a otro para el tratamiento y a otro más porque ninguno supo darte el blowout que querías. Cada clienta que se sienta en nuestra silla merece salir mejor de como entró.',
    stats: [
      { value: '4.7★', label: 'Calificación promedio' },
      { value: '6 días', label: 'Abiertos a la semana' },
      { value: '100%', label: 'Cabello humano en tienda' },
    ],
  },
  schedule: {
    eyebrow: 'Nuestro horario',
    title: 'Estamos aquí para ti 6 días a la semana',
    walkIn: 'No necesitas cita — solo llega',
    days: [
      { day: 'Lunes', hours: '9:00 AM – 6:00 PM' },
      { day: 'Martes', hours: '9:00 AM – 6:00 PM' },
      { day: 'Miércoles', hours: '9:00 AM – 6:00 PM' },
      { day: 'Jueves', hours: '9:00 AM – 6:00 PM' },
      { day: 'Viernes', hours: '9:00 AM – 7:00 PM', note: 'Horario extendido' },
      { day: 'Sábado', hours: '8:00 AM – 6:00 PM', note: 'Abrimos temprano' },
      { day: 'Domingo', hours: 'Cerrado' },
    ],
    friday: {
      lead: 'Los ',
      accent: 'viernes',
      rest: ' tenemos horario extendido hasta las 7 PM — perfecto para las mujeres que trabajan durante la semana.',
    },
    saturday: {
      lead: 'Los ',
      accent: 'sábados',
      rest: ' abrimos desde las 8 AM: empieza tu fin de semana como la reina que eres.',
    },
    privateParties: 'Disponible para reservas de fiestas privadas con aviso previo.',
  },
  contact: {
    eyebrow: 'Walk-ins Welcome · Sin Cita Necesaria',
    title: 'Todo lo que necesitas está aquí. Solo falta una cosa — tú.',
    intro:
      'Llámanos, escríbenos o simplemente entra. Tu transformación empieza en cuanto cruzas la puerta.',
    labels: {
      tel: 'Teléfono',
      cel: 'WhatsApp — reservas',
      dir: 'Dirección',
      ig: 'Instagram',
      ig2: 'Síguenos también en',
      mail: 'Email',
    },
    callNow: 'Llamar ahora',
    writeUs: 'Escríbenos',
  },
  footer: {
    quote: 'Entra como clienta. Sale como Reina.',
    notes: [
      'Servicios para hombres y mujeres',
      'Cabello 100% humano disponible en tienda',
      'Estilismo dominicano y universal',
      'Fiestas privadas con aviso previo',
    ],
    address: 'La Reina Beauty Salon · 2031 Forest Avenue, Staten Island, New York',
    rights: 'Todos los derechos reservados.',
  },
  legal: {
    updatedLabel: 'Actualizado el',
    close: 'Cerrar',
    contactNote:
      '¿Preguntas sobre estas políticas? Llámanos al (718) 273-3434, escríbenos por WhatsApp al (347) 853-1793 o envía un correo a lareinabeautysalon1@gmail.com.',
    privacy: {
      linkLabel: 'Privacidad',
      title: 'Política de privacidad',
      intro:
        'En La Reina Beauty Salon LLC (2031 Forest Avenue, Staten Island, NY 10303) tratamos tus datos con el mismo cuidado con el que tratamos tu cabello: solo pedimos lo necesario para atenderte bien.',
      sections: [
        {
          heading: 'Qué información recogemos',
          body: [
            'Cuando reservas por teléfono, WhatsApp, Instagram o directamente en el salón, guardamos tu nombre, tu número de contacto y el servicio que solicitas.',
            'Para servicios químicos, de color, tratamientos y extensiones también anotamos el historial de tu cabello (tratamientos anteriores, alergias o sensibilidades) para poder trabajar con seguridad.',
          ],
        },
        {
          heading: 'Para qué la usamos',
          body: [
            'Usamos tus datos únicamente para agendar y confirmar tus visitas, recordarte una cita, dar seguimiento a un servicio y responder a tus preguntas.',
            'Si nos das tu consentimiento expreso, podemos enviarte novedades del salón o promociones. Puedes pedirnos que dejemos de hacerlo en cualquier momento.',
          ],
        },
        {
          heading: 'Fotos y redes sociales',
          body: [
            'Nunca publicamos fotos de un trabajo sin tu autorización. Si nos autorizas, podemos compartir el resultado en nuestro Instagram o TikTok, y puedes pedirnos que lo retiremos cuando quieras.',
          ],
        },
        {
          heading: 'Con quién la compartimos',
          body: [
            'No vendemos, alquilamos ni intercambiamos tu información personal.',
            'Solo la comparten los miembros del equipo que necesitan verla para atenderte, y las plataformas que usamos para comunicarnos contigo (por ejemplo WhatsApp o Instagram), que se rigen por sus propias políticas.',
          ],
        },
        {
          heading: 'Pagos',
          body: [
            'Los pagos se realizan en el salón. No almacenamos números completos de tarjeta ni datos bancarios: los procesa directamente nuestro terminal de pago.',
          ],
        },
        {
          heading: 'Tus derechos',
          body: [
            'Puedes pedirnos en cualquier momento que te digamos qué datos tenemos, que los corrijamos o que los eliminemos de nuestros registros.',
            'Los datos de menores de edad solo se registran con el consentimiento de su madre, padre o tutor.',
          ],
        },
      ],
    },
    terms: {
      linkLabel: 'Términos',
      title: 'Términos y condiciones',
      intro:
        'Estos términos explican cómo funciona el servicio en La Reina Beauty Salon LLC para que tu visita sea clara y sin sorpresas.',
      sections: [
        {
          heading: 'Walk-ins y tiempos de espera',
          body: [
            'Atendemos sin cita previa. El orden de atención depende de la llegada y del tipo de servicio, por lo que en horas de alta demanda puede haber tiempo de espera.',
            'Si prefieres asegurar tu turno, escríbenos por WhatsApp al (347) 853-1793 antes de venir.',
          ],
        },
        {
          heading: 'Consulta previa y resultados',
          body: [
            'Los servicios de color, alisado, tratamientos químicos y extensiones requieren una consulta previa. El resultado depende del estado, la textura y el historial de tu cabello.',
            'Si tu cabello tiene tintes, decoloraciones o alisados anteriores, es posible que recomendemos un proceso en varias sesiones para proteger su salud. No garantizamos un resultado idéntico a una foto de referencia.',
          ],
        },
        {
          heading: 'Precios y pagos',
          body: [
            'Los precios se confirman antes de comenzar el servicio y pueden variar según el largo, la densidad, el tiempo de trabajo y los productos necesarios.',
            'El cabello 100% humano y otros productos vendidos en el salón se pagan en el momento de la compra.',
          ],
        },
        {
          heading: 'Ajustes y devoluciones',
          body: [
            'Los servicios ya realizados no son reembolsables. Si algo no quedó como conversamos, avísanos dentro de los 7 días siguientes y lo revisamos y ajustamos sin costo cuando corresponda.',
            'El cabello y los productos abiertos o ya utilizados no se aceptan en devolución por razones de higiene.',
          ],
        },
        {
          heading: 'Menores y acompañantes',
          body: [
            'Atendemos con gusto a niñas y niños acompañados por su madre, padre o tutor, quien debe autorizar el servicio y permanecer en el salón.',
          ],
        },
        {
          heading: 'Objetos personales y cuidado posterior',
          body: [
            'No nos hacemos responsables por objetos personales olvidados o dejados sin supervisión en el salón.',
            'Para que tu resultado dure, te damos recomendaciones de cuidado en casa. El uso de productos o herramientas de calor inadecuados puede afectar la duración del servicio.',
          ],
        },
        {
          heading: 'Fiestas privadas y eventos',
          body: [
            'Podemos reservar el salón o parte del equipo para bodas, quinceañeras, graduaciones y otros eventos con aviso previo y confirmación de fecha.',
          ],
        },
      ],
    },
  },
  gallery: {
    alts: [
      'Trenzas geométricas con particiones precisas realizadas en La Reina',
      'Corte en capas con blow dry dominicano y acabado brillante',
      'Recogido alto con rizos definidos para ocasión especial',
      'Cola de caballo larga con extensión ondulada',
      'Trenzas cosidas con cola trenzada en tono cobrizo',
      'Color vino intenso con ondas amplias y brillo espejo',
      'Trenzas infantiles con twists y accesorios dorados',
      'Cabello tratado con ondas voluminosas y brillo intenso',
    ],
  },
}
